export default "__VITE_ASSET__DN9T5BC$__"